import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DropDown } from './drop-down';
import { FormField } from './form-field';
export const DropDownField = ({ label, tooltip, options, onChange, selectedOptions = [], multiSelect = false, error, isRequired = false, fieldRef, placeholder, isDisabled = false, }) => {
    const id = React.useId();
    return (_jsx(FormField, { label: label, htmlFor: id, labelVariant: 'label', tooltip: tooltip, containerClassName: 'w-full h-full', isRequired: isRequired, error: error, children: _jsx(DropDown, { options: options, onChange: onChange, selectedOptionsValues: selectedOptions, multiSelect: multiSelect, placeholder: placeholder, fieldRef: fieldRef, hasError: !!error, isDisabled: isDisabled }) }));
};
